"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paletteValueToHueStep = void 0;
var _paletteValueToHueStepTuple = require("./paletteValueToHueStepTuple");
/**
 * Takes a paletteValue and extracts the hue step for the associated spectrum color.
 * @param paletteValue - 'blue60' | ['blue60', 0.4]
 * @returns number - 60
 */
const paletteValueToHueStep = paletteValue => {
  const _paletteValueToHueSte = (0, _paletteValueToHueStepTuple.paletteValueToHueStepTuple)(paletteValue),
    step = _paletteValueToHueSte[1];
  return step;
};
exports.paletteValueToHueStep = paletteValueToHueStep;